// extracted by mini-css-extract-plugin
module.exports = {"component":"facet-ClearAllActiveFacetsButton__component--3Ida4"};